import React from 'react';
import NavBar from './NavBar';

// The side navigation is self-contained (logo + links + mobile drawer) in NavBar.
const SideNavbar = () => <NavBar />;

export default SideNavbar;
